import {
    GET_STATES_LIST_PROGRESS, GET_STATES_LIST_SUCCESS, GET_STATES_LIST_FAILURE,
   
    RESET_MESSAGE,

} from '../types/actionTypes';

const initialState = {
    allStates: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const states_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_STATES_LIST_SUCCESS:
            return { ...state, allStates: action.allStates, loading: false };
        case GET_STATES_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_STATES_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
      
        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default states_reducer;